import type { WarungIdentity, WarungSubscription } from '@/types/warung'

export type SubscriptionUrgency = 'ok' | 'warning' | 'critical'

export interface SubscriptionStatus {
  readonly planCode: 'free' | 'pro' | null
  readonly planLabel: string | null
  readonly isTrial: boolean
  readonly inGrace: boolean
  readonly periodDateLabel: string | null
  readonly daysRemaining: number | null
  readonly daysRemainingLabel: string | null
  readonly urgency: SubscriptionUrgency
}

const periodFormatter = new Intl.DateTimeFormat('id-ID', { day: 'numeric', month: 'short', year: 'numeric' })

export function getSubscriptionStatus(subscription: WarungSubscription | null, now = Date.now()): SubscriptionStatus {
  const planCode = subscription?.plan.code ?? null
  const planLabel = planCode === 'pro' ? 'PRO' : planCode === 'free' ? 'FREE' : null
  const isTrial = planCode === 'pro' && subscription?.source === 'trial'
  const inGrace = subscription?.graceUntil != null
  const effectiveUntilIso = subscription?.graceUntil ?? subscription?.currentPeriodEnd ?? null
  const effectiveUntil = effectiveUntilIso === null || effectiveUntilIso === undefined ? null : new Date(effectiveUntilIso)
  const periodDateLabel = effectiveUntil === null ? null : periodFormatter.format(effectiveUntil)
  const daysRemaining = effectiveUntil === null ? null : Math.ceil((effectiveUntil.getTime() - now) / 86_400_000)
  const daysRemainingLabel = daysRemaining === null
    ? null
    : daysRemaining <= 0 ? 'Segera perbarui' : daysRemaining === 1 ? '1 hari lagi' : `${daysRemaining} hari lagi`
  const urgency: SubscriptionUrgency = inGrace
    ? 'critical'
    : daysRemaining === null ? 'ok' : daysRemaining <= 0 ? 'critical' : daysRemaining <= 7 ? 'warning' : 'ok'

  return { planCode, planLabel, isTrial, inGrace, periodDateLabel, daysRemaining, daysRemainingLabel, urgency }
}

export interface ReceiptIdentity {
  readonly businessName: string
  readonly address: string | null
}

const FREE_BUSINESS_NAME = 'Galeh Rancak'
const FREE_BUSINESS_ADDRESS = 'galehrancak.id'

// Struk hanya menampilkan identitas usaha untuk warung Pro. Warung Free tetap
// memakai identitas Galeh Rancak agar tidak mempublikasikan nama usaha di
// struk sebelum berlangganan Pro. Format ini disamakan dengan aplikasi mobile.
export function getReceiptIdentity(subscription: WarungSubscription | null, warung: WarungIdentity | null | undefined): ReceiptIdentity {
  const isPro = subscription?.plan.code === 'pro'
  const name = warung?.name.trim()
  const address = warung?.area.trim()
  if (isPro && name) {
    return { businessName: name, address: address ? address : null }
  }
  return { businessName: FREE_BUSINESS_NAME, address: FREE_BUSINESS_ADDRESS }
}
